import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { TbReportSearch } from "react-icons/tb";
import "../../borrowSystem/Report/ListReports.css"

export function ListReportViewSupport4Component() {
    const user = JSON.parse(localStorage.getItem("userData"));
    return (
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center ">

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport4"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 4</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport41"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 5</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-1)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport42"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 6</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-2)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport43"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 7</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-3)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport44"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 8</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-4)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport45"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 9</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-5)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to="/supporting/report/viewreport46"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 10</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-6)
                        </span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to={`/supporting/report/${user.roldId === "3" ? "Addviewreport47" : "viewreport47"}`}
                        // to="/supporting/report/viewreport47"
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 11</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-7)
                        </span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to={`/supporting/report/${user.roldId === "3" ? "Addviewreport48" : "viewreport48"}`}
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 12</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-8)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to={`/supporting/report/${user.roldId === "3" ? "Addviewreport49" : "viewreport49"}`}
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 13</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-9)</span>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to={`/supporting/report/${user.roldId === "3" ? "Addviewreport410" : "viewreport410"}`}
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 14</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-10)</span>
                    </Link>
                </div><div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link
                        to={`/supporting/report/${user.roldId === "3" ? "Addviewreport411" : "viewreport411"}`}
                        style={{ textDecoration: "none" }}
                    >
                        <TbReportSearch className="icon-doc" />
                        <p className="px-3">รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน
                        </p>
                        <p>
                            <span>ตามประกาศข้อ 15</span>
                        </p>
                        <span style={{ fontWeight: "bold", fontSize: "1.4rem" }}>(ชอ. 4-11)</span>
                    </Link>
                </div>


            </div>
            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>
    )
}